<template>
  <div class="tracks-view-toggle" role="group" aria-label="Вид треков">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="tracks-view-toggle__button"
      :class="{ 'tracks-view-toggle__button--active': option.value === modelValue }"
      :aria-pressed="option.value === modelValue"
      @click="$emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    required: true,
  },
})

defineEmits(['update:modelValue'])

const options = [
  { value: 'dashboard', label: 'Колонки' },
  { value: 'map', label: 'Карта' },
]
</script>

<style scoped>
.tracks-view-toggle {
  display: inline-flex;
  flex-shrink: 0;
  gap: 0.25rem;
  padding: 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #fff;
}

.tracks-view-toggle__button {
  border: none;
  border-radius: 999px;
  padding: 0.5rem 0.875rem;
  background: transparent;
  color: #334155;
  cursor: pointer;
  font-size: 0.875rem;
  white-space: nowrap;
}

.tracks-view-toggle__button--active {
  background: #2563eb;
  color: #fff;
}
</style>
